import React from 'react';
import { Heart, X, Check, Activity } from 'lucide-react';
export function FalseSolutions() {
  return <section className="py-16 px-4 bg-[#FDFAF7] text-center border-t border-[#E2E8F0]" data-id="element-39">
      <div className="max-w-[800px] mx-auto" data-id="element-40">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#1C1C2E] mb-2" data-id="element-41">
          Por Qué Todo Lo Que Has Intentado Se Siente Insuficiente
        </h2>
        <div className="flex items-center justify-center gap-2 text-[#1B3A6B] font-medium mb-10" data-id="element-42">
          <Activity className="w-5 h-5" data-id="element-43" />
          <span data-id="element-44">La Verdad que Nadie te Cuenta sobre el Apoyo Familiar</span>
        </div>

        {/* Comparison Table */}
        <div className="bg-white rounded-xl shadow-sm border border-[#E2E8F0] overflow-hidden mb-12" data-id="element-45">
          <div className="grid grid-cols-2 bg-[#EEF2F7] border-b border-[#E2E8F0]" data-id="element-46">
            <div className="p-4 font-bold text-[#4A4A6A] text-xs md:text-sm uppercase tracking-wider" data-id="element-47">
              Lo Que Hacemos Por Instinto
            </div>
            <div className="p-4 font-bold text-[#1B3A6B] text-xs md:text-sm uppercase tracking-wider bg-[#1B3A6B]/5" data-id="element-48">
              Lo Que Realmente Ayuda
            </div>
          </div>

          <div className="divide-y divide-[#E2E8F0]" data-id="element-49">
            {[{
            bad: 'Decir "Vas a estar bien"',
            good: 'Escuchar el miedo sin juzgar'
          }, {
            bad: 'Visitar todos los días (agotador)',
            good: 'Visitas de calidad y coordinadas'
          }, {
            bad: 'Ocultar nuestra tristeza',
            good: 'Vulnerabilidad compartida'
          }, {
            bad: 'Adivinar qué necesita',
            good: 'Preguntas guía específicas'
          }, {
            bad: 'Hacerlo todo solo',
            good: 'Sistema de roles familiares'
          }].map((row, i) => <div key={i} className="grid grid-cols-2 text-sm md:text-base" data-id="element-50">
                <div className="p-4 text-[#B83A52] flex items-center gap-2 justify-center md:justify-start bg-[#FDF0F3]/30" data-id="element-51">
                  <X className="w-4 h-4 shrink-0 opacity-60" data-id="element-52" />
                  <span data-id="element-53">{row.bad}</span>
                </div>
                <div className="p-4 text-[#1B3A6B] font-medium bg-[#1B3A6B]/5 flex items-center gap-2 justify-center md:justify-start" data-id="element-54">
                  <Check className="w-4 h-4 shrink-0" data-id="element-55" />
                  <span data-id="element-56">{row.good}</span>
                </div>
              </div>)}
          </div>
        </div>

        {/* The Turn - Insight */}
        <div className="bg-[#1B3A6B] text-[#FDFAF7] p-8 rounded-2xl relative overflow-hidden text-left shadow-navy-medium" data-id="element-57">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#335C94] rounded-full blur-[80px] opacity-30 -translate-y-1/2 translate-x-1/2" data-id="element-58"></div>

          <div className="relative z-10" data-id="element-59">
            <div className="flex items-center gap-3 mb-6" data-id="element-60">
              <Heart className="w-6 h-6 text-[#B83A52] fill-[#B83A52]" data-id="element-61" />
              <h3 className="text-xl md:text-2xl font-serif font-bold" data-id="element-62">
                El Tratamiento Invisible
              </h3>
            </div>

            <div className="space-y-4 mb-8 text-[#EEF2F7] leading-relaxed" data-id="element-63">
              <p data-id="element-64">
                Aquí está la verdad que los médicos no tienen tiempo de
                explicarte:
              </p>
              <p className="font-serif text-lg md:text-xl italic text-white border-l-4 border-[#B83A52] pl-4 py-1" data-id="element-65">
                "El tratamiento más poderoso que existe para un paciente de
                cáncer no viene de una farmacia. Viene de su familia. Cuando
                sabe cómo acompañar."
              </p>
              <p data-id="element-66">
                Las investigaciones en psicooncología son claras: Un paciente
                con una red familiar activa, organizada y emocionalmente
                presente tiene mayor adherencia al tratamiento y mejor calidad
                de vida.
              </p>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-white/10" data-id="element-67">
              <p className="text-sm font-medium text-[#EEF2F7]" data-id="element-68">
                <span className="text-[#FCD34D] font-bold" data-id="element-69">
                  No es opinión. Es ciencia.
                </span>
              </p>
              <p className="text-xs md:text-sm font-bold text-[#EEF2F7] text-center md:text-right" data-id="element-70">
                El problema no es que tu familia no ame suficiente.
                <br data-id="element-71" />
                <span className="text-[#B83A52] font-bold" data-id="element-72">
                  El problema es que nadie le dio un sistema.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}